<template>
  <div class="support-page">
    <div class="page-wrapper">
      <h1 class="h1">WE WANT TO HEAR FROM YOU</h1>
      <p>
        Please fill out the form below if you have any further questions,
        comments, or concerns regarding Emory University's 175th Commencement or
        future commencement celebrations for the Class of 2020.
      </p>
      <v-form
        ref="form"
        lazy-validation
        v-model="isFormValid"
        @submit.prevent="submit"
      >
        <v-layout :wrap="['sm', 'xs'].includes($size)">
          <v-flex xs12 sm12 md6>
            <v-text-field
              :rules="[validation.required]"
              v-model="form.first_name"
              label="First name"
              validate-on-blur
            ></v-text-field>
          </v-flex>
          <v-flex class="px-3"></v-flex>
          <v-flex xs12 sm12 md6>
            <v-text-field
              :rules="[validation.required]"
              v-model="form.last_name"
              label="Last name"
              validate-on-blur
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout :wrap="['sm', 'xs'].includes($size)">
          <v-flex xs12 sm12 md6>
            <v-text-field
              :rules="[validation.required, validation.email]"
              v-model="form.email"
              type="email"
              label="Email address"
              validate-on-blur
            ></v-text-field>
          </v-flex>
          <v-flex class="px-3"></v-flex>
          <v-flex xs6></v-flex>
        </v-layout>
        <br />
        <v-textarea
          :rules="[validation.required]"
          v-model="form.message"
          label="Message"
          validate-on-blur
          outlined
          counter="500"
          maxlength="500"
        ></v-textarea>

        <v-btn :disabled="loading" large type="submit" color="primary">{{
          loading ? "Processing..." : "Submit"
        }}</v-btn>
        <br />
        <br />
        <Recaptcha />
      </v-form>
    </div>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";

export default {
  name: "HelpPage",
  extends: formMixin,
  metaInfo: {
    titleTemplate: "%s - Help",
  },
  data() {
    return {
      loading: false,
      form: {},
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        if (!this.validate()) return;
        await this.$recaptchaLoaded();
        const recaptcha = await this.$recaptcha("login");

        await this.$api.Help.create({ help: this.form, recaptcha });
        this.form = {};
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
